import API_URLS from '@/api/API_URLS.js';
import { httpGet } from '@/api/request';
export const query = () => httpGet(API_URLS.WEATHER_URL);
export const user = 'userAPIURL';
export const user1 = 'user1APIURL';